"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportControls = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
const mol_state_1 = require("molstar/lib/mol-state");
const file_1 = require("molstar/lib/mol-plugin-state/actions/file");
const structure_1 = require("molstar/lib/mol-plugin-state/actions/structure");
const apply_action_1 = require("molstar/lib/mol-plugin-ui/state/apply-action");
const base_1 = require("molstar/lib/mol-plugin-ui/base");
const icons_1 = require("molstar/lib/mol-plugin-ui/controls/icons");
class ImportControls extends base_1.CollapsableControls {
    defaultState() {
        return {
            header: 'Import',
            isCollapsed: false,
            brand: { accent: 'gray', svg: icons_1.FileOutlineSvg }
        };
    }
    renderControls() {
        return (0, jsx_runtime_1.jsxs)("div", { className: 'msp-control-offset', style: { paddingTop: '1px' }, children: [(0, jsx_runtime_1.jsx)(apply_action_1.ApplyActionControl, { state: this.plugin.state.data, action: file_1.OpenFiles, nodeRef: mol_state_1.StateTransform.RootRef, initiallyCollapsed: true }, `${file_1.OpenFiles.id}`), (0, jsx_runtime_1.jsx)(apply_action_1.ApplyActionControl, { state: this.plugin.state.data, action: structure_1.DownloadStructure, nodeRef: mol_state_1.StateTransform.RootRef, initiallyCollapsed: true }, `${structure_1.DownloadStructure.id}`)] });
    }
}
exports.ImportControls = ImportControls;
